import React from "react";
import { Button } from "antd";
import Modal from "react-bootstrap/Modal";
import FormLoader from "swfrontend/MDM/MDMScreens/FormView/FormLoader";
import { openNotification } from "swfrontend/COMS/NotificationMessageMapping";
import {
  notificationMessage,
  notificationTitle,
  openNotificationType,
} from "swfrontend/MDM/MDMUIConfigs/MDMUIMappings";
import AndtDTextBoxWrapper from "swfrontend/MDM/MDMAntdWrappers/TextBoxWrapper";
import { localStorageVariableName } from "swfrontend/AppConfigs";
import AuthDataProvider from "../../AuthDataProvider";
import { URLS } from "../../constants";
import { NOTIFICATIONS } from "../../../LandingPage/constants";

class Timer extends React.Component {
  DataProvider = new AuthDataProvider();

  state = {
    seconds: localStorage.getItem("otp-duration"),
    isLoading: false,
  };

  componentDidMount() {
    this.startTimer();
  }

  startTimer = () => {
    try {
      if(this.state.seconds === null){
        return;
      }
      const t = setInterval(() => {
        this.setState({ seconds: this.state.seconds - 1 }, () => {
          if (this.state.seconds === 0) {
            clearInterval(t);
          }
        });
      }, 1000);
    } catch (error) {}
  };

  resendOtp = () => {
    try {
      this.setState({ isLoading: true });

      const username = localStorage.getItem(localStorageVariableName.userName);
      let values = { username }

      if(this.props.currentStep !== undefined){
        values.screen = "OTP Verification"
      }

      this.DataProvider.post_api_call(`${URLS.FORGET_PASSWORD}`, values)
        .then((res) => {
          if (res.ok) {
            return res.json().then((res) => {
              openNotification(
                openNotificationType.success,
                Object.keys(res)[0],
                res.Success
              );

              this.setState({ seconds: res.duration }, () => this.startTimer());
            });
          } else {
            return res.json().then((res) => {
              Object.keys(res).map((error) => {
                openNotification(openNotificationType.error, error, res[error]);
              });
            });
          }
        })
        .finally(() => this.setState({ isLoading: false }));
    } catch (error) {
      openNotification(
        openNotificationType.error,
        NOTIFICATIONS.ERROR_OCCURED,
        NOTIFICATIONS.REFRESH_PAGE
      );
    }
  };

  render() {
    const { seconds, isLoading } = this.state;
    const { formRef } = this.props;
    return (
      <>
        <Modal show={isLoading} centered>
          <Modal.Body>
            <FormLoader loading="true" />
          </Modal.Body>
        </Modal>

        <AndtDTextBoxWrapper
          decorator="otp"
          id="OTP"
          required="true"
          label="OTP"
          message="Enter OTP"
          placeholder="Enter OTP"
          validators=""
          disabled={seconds === 0 ? true : false}
          formRef={formRef}
        />

        {seconds === 0 ? (
          <Button type="link" onClick={this.resendOtp}>
            Resend OTP
          </Button>
        ) : (
          <p className="otp-text">
            OTP expire in &nbsp;
            <font color="red">{seconds}</font> seconds
          </p>
        )}
      </>
    );
  }
}

export default Timer;
